import { Drawer } from '@mui/material';
import { LeftMenuContent } from './content';

type MobileMenuProps = {
  width: number;
  isMenuOpen: boolean;
  onMenuToggle: () => void;
};

export const MobileMenu = ({
  width,
  isMenuOpen,
  onMenuToggle,
}: MobileMenuProps) => {
  return (
    <Drawer
      variant="temporary"
      open={isMenuOpen}
      onClose={onMenuToggle}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        display: { xs: 'block', sm: 'none' },
        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: width },
      }}
    >
      <LeftMenuContent isExpanded={true} isMobile={true} />
    </Drawer>
  );
};
